<template>
  <generic-modal
    :title="$t('sale')"
    icon="payment"
    image="/images/icons/receipt-1.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    :footer_buttons="footer_buttons"
  >
    <div class="description">
      <div class="ui shape" ref="shape">
        <div class="sides">
          <div class="active side">
            <h4 class="ui dividing header">{{ $t("product list") }}</h4>
            <div class="ui divided list" v-if="sale">
              <div
                class="item"
                v-for="(prod, index) in sale.pos_sold_products"
                :key="index"
              >
                <i class="right triangle icon"></i>
                <div class="content">
                  <span
                    class="ui right floated large text"
                    style="margin-top:7px"
                  >
                    {{ prod.subtotal | formatCurrency }}
                  </span>
                  <div class="header">{{ prod.prd_product.name }}</div>
                  <div class="description">
                    {{ prod.quantity }} x
                    {{
                      prod.sale_price
                        | formatCurrency(enterprise_setup.currency_iso)
                    }}
                    <span class="ui red text" v-if="prod.discount"
                      >({{ prod.discount }}%)</span
                    >
                  </div>
                </div>
              </div>
              <div class="ui small red horizontal statistic">
                <div class="value">
                  {{
                    sale.total | formatCurrency(enterprise_setup.currency_iso)
                  }}
                </div>
                <div class="label">{{ $t("total") }}</div>
              </div>
            </div>
            <h4 class="ui dividing header">{{ $t("payment") }}</h4>
            <div class="ui divided list" v-if="sale">
              <div
                class="item"
                v-for="(paymnt, index) in sale.payment"
                :key="index"
                v-bind:class="{ hidden: !paymnt.amount }"
              >
                <i class="money icon"></i>
                <div class="content">
                  <span
                    class="ui right floated large text"
                    style="margin-top:2px"
                  >
                    {{ paymnt.amount | formatCurrency }}
                  </span>
                  <div class="header">{{ paymnt.name }}</div>
                  <div class="description"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="side">
            <receipt
              v-if="sale"
              id="receipt_print"
              :sale_in="sale"
              :template_in="receipt_template.template"
            />
          </div>
        </div>
      </div>
      <!-- <pre>{{ sale }}</pre> -->
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";
// import _ from "lodash";
import GenericModal from "@/components/GenericModal";
import Receipt from "./Receipt";
import PHE from "print-html-element";

export default {
  name: "SaleModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    Receipt,
  },
  props: { sale_uuid: String },
  data() {
    return {
      sale: undefined,
      footer_buttons: [
        {
          text: this.$t("toggle view"),
          icon: "exchange",
          color: "olive",
          click: this.show_receipt,
        },
        {
          text: this.$t("print"),
          icon: "print",
          color: "orange",
          click: this.print_receipt,
          visibility_condition: false,
        },
      ],
      receipt_template: {},
      is_receipt_showing: false,
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    finished() {
      // let vm = this;
      // eslint-disable-next-line no-unused-vars
      return new Promise(function(resolve, reject) {
        resolve();
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    show_receipt() {
      let vm = this;
      window.jQuery(vm.$refs.shape).shape("flip back");
      vm.is_receipt_showing = !vm.is_receipt_showing;
      let btn = vm.footer_buttons.find((b) => b.icon == "print");
      if (btn) {
        btn.visibility_condition = vm.is_receipt_showing;
      }
    },
    print_receipt() {
      let trgt = document.getElementById("receipt_print");
      // let opts = {
      //   pageTitle: vm.$t("inscription receipt"),
      //   styles: vm.info.template.template.css,
      // };
      PHE.printElement(trgt);
    },
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/point_of_sale/do-get-sale", { u: vm.sale_uuid })
      .then((sale) => {
        vm.sale = sale;
      })
      .catch((err) => {
        error_toast(err);
      });

    local_api(this, "post", "/point_of_sale/do-get-configuration")
      .then((r) => {
        let conf = r.conf_pos;
        if (conf && conf.setup && conf.setup.receipt_templates) {
          vm.receipt_template = conf.setup.receipt_templates.find(
            (t) => t.set_as_default,
          );
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
